import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { Callout, Intent, Button, Divider } from '@blueprintjs/core';
import { launchDownloadLink, launchWindowsDownload, launchOSXDownload } from 'app/utils/downloads';
import { translateKey } from 'app/utils/forms';


interface Props {
    user: UserState;
};

interface State {}

export class DownloadView extends React.Component<Props, State> {

    state: State = {}


	render() {

        return <span>
            <Callout intent={Intent.PRIMARY} title="vLeader Downloads">
                <p>{translateKey('vleader.download')}</p>
                <Button style={{width: '300px'}} icon={"download"} large={true} intent={Intent.SUCCESS} onClick={()=>{launchDownloadLink()}}>{translateKey('vleader.downloadAuto')}</Button>
                <Divider style={{marginTop: '20px', marginBottom: '20px'}} />
                <p>{translateKey('vleader.download2')}</p>
                <Button style={{marginRight: '20px'}} icon={"download"} intent={Intent.NONE} onClick={()=>{launchWindowsDownload()}}>{translateKey('vleader.windowsButton')}</Button>
                <Button icon={"download"} intent={Intent.NONE} onClick={()=>{launchOSXDownload()}}>{translateKey('vleader.osxButton')}</Button>
            </Callout>
        </span>
	}
}
